export const modalWidth = 750
export const responsiveModalWidth = '75vw'
export const drawerAndModalWidth = 720
export const smallModalWidth = 500
